var _path, _rect, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H87.0858L99 12.9142V99H1V1Z",
    stroke: "#CACACA",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 47.1432,
    y: 30,
    width: 5.71429,
    height: 33.3333,
    fill: "#CACACA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 60.4763L43.9999 56.6668L53.9997 66.1906L49.9998 70.0001L40 60.4763Z",
    fill: "#CACACA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0001 56.6667L60 60.4763L49.9998 70.0001L46.0003 66.1906L56.0001 56.6667Z",
    fill: "#CACACA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropTooltip);
export default __webpack_public_path__ + "static/media/drop_tooltip.edd6d95e52dd392a65a9939b44339985.svg";
export { ForwardRef as ReactComponent };